import {routerReducer as routing} from "react-router-redux"
import {combineReducers} from "redux"
import {RESET_ALERTS, CHANGE_HEADER_CONTENT} from "../actions"
import paginate from "./paginate"
import entity from "./entity"
import {SHOW_MODAL, HIDE_MODAL} from "../actions/modal"
import * as OnlineActions from '../actions/online'

const defaultAlerts = {type: null, messages: []};

const alerts = (state = defaultAlerts, action) => {
	const {type, error, success, silent = false} = action;

	if (type === RESET_ALERTS) {
		return {
			...state,
			type: null,
			messages: []
		}

	} else if ((error || success) && !silent && type.indexOf("@@redux-form") !== 0) {
		const messages = Object.assign(state.messages);
		if (messages.length > 5) {
			messages.shift()
		}
		messages.push(error || success);
		return {
			type: error ? 'danger' : 'success',
			messages
		}
	}

	return state
};

const headerContent = (state = {content: null}, action) => {
	const {type, content} = action;

	if (type === CHANGE_HEADER_CONTENT) {
		return Object.assign({}, state, {
			content: content
		})
	} else {
		return state
	}
};

const pagination = combineReducers({
	seasons: paginate({
		types: [
			OnlineActions.SEASONS_REQUEST,
			OnlineActions.SEASONS_SUCCESS,
			OnlineActions.SEASONS_FAILURE
		]
	}),
	races: paginate({
		types: [
			OnlineActions.RACES_REQUEST,
			OnlineActions.RACES_SUCCESS,
			OnlineActions.RACES_FAILURE
		]
	}),
});

const entities = combineReducers({
	races: entity({
		types: [
			OnlineActions.RACE_REQUEST,
			OnlineActions.RACE_SUCCESS,
			OnlineActions.RACE_FAILURE
		],
		key: 'id'
	}),
	raceResults: entity({
		types: [
			OnlineActions.RACE_RESULT_REQUEST,
			OnlineActions.RACE_RESULT_SUCCESS,
			OnlineActions.RACE_RESULT_FAILURE
		],
		key: 'id'
	}),
	raceResultIntermediates: entity({
		types: [
			OnlineActions.RACE_RESULT_INTER_REQUEST,
			OnlineActions.RACE_RESULT_INTER_SUCCESS,
			OnlineActions.RACE_RESULT_INTER_FAILURE
		],
		key: 'id'
	}),
});

const defaultModalState = {isShowing: false, title: '', message: '', button: null, onConfirm: null};

function modal(state = defaultModalState, action) {
	switch (action.type) {
		case SHOW_MODAL:
			return Object.assign({}, state, {
				isShowing: true,
				message: action.message,
				title: action.title,
				button: action.button,
				onConfirm: action.onConfirm
			});
		case HIDE_MODAL:
			return Object.assign({}, state, defaultModalState);
		default:
			return state
	}
}

const rootReducer = combineReducers({
	headerContent,
	pagination,
	entities,
	alerts,
	routing,
	modal
});

export default rootReducer



// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/reducers/index.js